/**
 * P3-21: BurnParagonButton / TurnHGOffButton —— MetaphysicsPanel 中的
 * ButtonModern 按钮（迁移自 js/prestige.js:603-653）。
 */
import { useCallback, type MouseEvent } from "react";
import { GameButton } from "../../components/GameButton";
import {
  useBurnParagonButtonModel,
  useTurnHGOffButtonModel,
} from "./useScienceModel";

interface BurnParagonButtonProps {
  name: string;
  description: string;
  handler: () => void;
}

export function BurnParagonButton({
  name,
  description,
  handler,
}: BurnParagonButtonProps) {
  const { snap, modelRef, controller, getTooltip } =
    useBurnParagonButtonModel(name, description, handler);

  const onClick = useCallback(
    (event: MouseEvent) => {
      const model = modelRef.current;
      if (controller && model) {
        controller.buyItem?.(model, event);
      }
    },
    [controller, modelRef],
  );

  if (!snap || !snap.visible) {
    return null;
  }

  return (
    <GameButton
      name={snap.name}
      description={snap.description}
      enabled={snap.enabled}
      resourceIsLimited={snap.resourceIsLimited}
      getTooltip={getTooltip}
      onClick={onClick}
    />
  );
}

interface TurnHGOffButtonProps {
  name: string;
  description: string;
  handler: () => void;
}

export function TurnHGOffButton({
  name,
  description,
  handler,
}: TurnHGOffButtonProps) {
  const { snap, modelRef, controller, getTooltip } =
    useTurnHGOffButtonModel(name, description, handler);

  const onClick = useCallback(
    (event: MouseEvent) => {
      const model = modelRef.current;
      if (controller && model) {
        controller.buyItem?.(model, event);
      }
    },
    [controller, modelRef],
  );

  if (!snap || !snap.visible) {
    return null;
  }

  return (
    <GameButton
      name={snap.name}
      description={snap.description}
      enabled={snap.enabled}
      resourceIsLimited={snap.resourceIsLimited}
      getTooltip={getTooltip}
      onClick={onClick}
    />
  );
}
